type Fn = (() => void) | null;

const registry = new Map<string, Fn>();

export const setHandler = (id: string, fn: Fn) => {
    if (!id) return;
    if (fn) registry.set(id, fn);
    else registry.delete(id);
};

export const getHandler = (id: string): Fn => {
    return registry.get(id) ?? null;
};

export const removeHandler = (id: string) => {
    registry.delete(id);
};
